import { render, staticRenderFns } from "./AllInOneCard.vue?vue&type=template&id=0970e07f&scoped=true&"
import script from "./AllInOneCard.vue?vue&type=script&lang=js&"
export * from "./AllInOneCard.vue?vue&type=script&lang=js&"
import style0 from "./AllInOneCard.vue?vue&type=style&index=0&id=0970e07f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970e07f",
  null
  
)

export default component.exports